import { useTranslation } from 'react-i18next';
import { CenterForm } from './CenterForm';

export const ViewCenter = () => {
	const { t } = useTranslation();
	return (
		<>
			<h2>{t('viewCenter')}</h2>
			<CenterForm forViewing />
		</>
	);
};
